<template>
  <ProductContentDetails
    :offer="offer"
    headline="Technische Details"
    class="feature-list"
  >
    <template #default="slotProps">
      <Charger
        v-if="slotProps.product?.commonCharger?.possible"
        class="feature-list__charger"
        :common-charger="slotProps.product.commonCharger"
      />
      <TechnicalDetails
        :features="getFeatures(slotProps.product)"
        :documents="documents"
      />
    </template>
  </ProductContentDetails>
</template>

<script setup lang="ts">
import { withDefaults, computed } from 'vue';
import ProductContentDetails from '~/components/product-detail/tabs/product-content-details.vue';
import TechnicalDetails from '~/components/product-detail/tabs/technical-details.vue';
import { Charger } from '@i22/td-longtail-vue-components';
import { getStandardProduct, type Offer, type OfferProduct } from '~/lib/goliath/offer-by-slugs';

export type FeatureListProps = {
  offer?: Offer;
};

const props = withDefaults(defineProps<FeatureListProps>(), {
  offer: undefined,
});

// documents are on the Offer, features on the Product!
const documents = computed(() => props.offer?.documents || []);

const getFeatures = (product: OfferProduct) => {
  const features: { name: string; value: any }[] = [];
  if (product.eans) {
    features.push({
      name: 'GTIN',
      value: product.eans.join(', '),
    });
  }

  const standardProduct = getStandardProduct(product);
  if (standardProduct) {
    standardProduct.features?.forEach((f) => {
      if (f?.name && f.value !== undefined && f.value !== null) {
        features.push({
          name: f.name,
          value: f.value,
        });
      }
    });
  }

  return features;
};
</script>

<style lang="scss" scoped>
.feature-list {
  &__charger {
    font-size: 5em;
  }
}
</style>
